module.exports = __webpack_public_path__ + "img/setting_24.8830c4e5.svg";